/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandBootstrap = createReactComponent("outline", "brand-bootstrap", "IconBrandBootstrap", [["path", { "d": "M2 12a2 2 0 0 0 2 -2v-4a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4a2 2 0 0 0 2 2", "key": "svg-0" }], ["path", { "d": "M2 12a2 2 0 0 1 2 2v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-4a2 2 0 0 1 2 -2", "key": "svg-1" }], ["path", { "d": "M9 16v-8h3.5a2 2 0 1 1 0 4h-3.5h4a2 2 0 1 1 0 4h-4z", "key": "svg-2" }]]);

export { IconBrandBootstrap as default };
//# sourceMappingURL=IconBrandBootstrap.mjs.map
